import { OnPremNHIBlockPage } from '../OnPremNHIBlockPage/OnPremNHIBlockPage';
import { usePricingModulesState } from '../../../../context/contexts/PricingModuleContext';
import { LogicalRoute, LogicalRouteImportProps } from '../../../../routings/helpers/LogicalRoute';
import ServiceAccountWrapper from '../ServiceAccountWrapper';
import { Pages, Roles } from '../../../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../../../hooks/useHasPermissions';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const NhiOnPermRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const displayBlockPage = isPageBlocked(LAYOUT_TABS.SERVICE_ACCOUNTS.ID);
    const disabled = !useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={ServiceAccountWrapper}
            blockPageComponent={OnPremNHIBlockPage}
            displayBlockPage={displayBlockPage}
            disabled={disabled}
        />
    );
};
